<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="d-flex-column justify-start align-start gap-5">
      <div class="d-flex-row justify-start gap-5">
        <label class="t-white font-family-1 regular-l f-w-600">
          {{ $t("dashboard.extra_options") }}
        </label>
        <ItemTooltip :text="selectedOptionDescription" />
      </div>

      <div
        class="cart_option_container b-radius-6 cursor-pointer"
        @click.stop="toggleOpen"
        v-click-outside="closeOpen"
      >
        <div class="d-flex-row flex-8 justify-start">
          <p
            class="t-grey font-family-2 white-space-no regular-l"
            style="text-overflow: ellipsis; max-width: 25ch; overflow: hidden"
          >
            {{ selectedOptions }}
          </p>
        </div>
        <ChevDown />

        <Transition name="slide-fade-top">
          <div class="divisions_list_container" v-if="isOpen">
            <div
              class="item"
              v-for="option in packOptions"
              :key="option"
              :class="[isOptionSelected(option.id) && 'active_item']"
              @click.stop="selectOption(option)"
            >
              <div class="d-flex-row space-between">
                <p class="font-family-2 regular-l t-white">
                  {{ option.title }}
                </p>
                <p
                  class="t-blue font-family-2 white-space-no regular-l text-capitalize"
                >
                  {{ renderPrice(option) }}
                </p>
              </div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
import Checkbox from "~/components/custom/Checkbox.vue";
import ChevDown from "~/components/icons/ChevDown.vue";
import { calculateCurrency } from "~/calculate/calculatePrice";
import { eventBus } from "~/lib/eventBus";
const isOpen = ref(false);

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
  eventBus.emit("closeAll");
};

const closeOpen = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const emit = defineEmits(["closeParentDrop"]);

const { getGame, getGamePack } = useGameStore();
const { getUserCurrency } = useUserStore();
const checkoutStore = useCheckoutStore();

const oneTrickOption = computed(() => {
  return packOptions.value?.find((op) => op.const_title === "one_trick_pony");
});
const packOptions = computed(() => {
  const gamePackOptions =
    getGamePack.pack_options?.filter(
      (packOp) =>
        packOp?.const_title !== "self_play" &&
        !packOp?.const_title?.includes("_extra_boosters")
    ) || [];
  let parsedGameOptions = [];
  gamePackOptions.forEach((option) => {
    if (option.rules.bonus) {
      let key = "";
      if (checkoutStore.getDetails.desiredRankTitle) {
        if (!checkoutStore.getDetails.desiredDivisionTitle) {
          key = checkoutStore.getDetails.desiredRankTitle;
        } else {
          key =
            checkoutStore.getDetails.desiredRankTitle +
            " " +
            checkoutStore.getDetails.desiredDivisionTitle;
        }
      } else {
        if (!checkoutStore.getDetails.currentDivisionTitle) {
          key = checkoutStore.getDetails.currentRankTitle;
        } else {
          key =
            checkoutStore.getDetails.currentRankTitle +
            " " +
            checkoutStore.getDetails.currentDivisionTitle;
        }
      }
      const rank = option.rules.bonus[key];
      if (rank) {
        let rp = rank;
        option.price = parseFloat(parseFloat(rp).toFixed(2));
        option.type = "fixed";
      }
    }
  });
  return gamePackOptions;
});

const switchClick = (option) => {
  // selectOption(option);
};

const renderPrice = (packOption) => {
  if (packOption.type === "free") {
    return packOption.type;
  } else if (packOption.type === "variable") {
    return `+${packOption.price}%`;
  } else if (packOption.type === "fixed") {
    return `+${parseFloat(calculateCurrency(packOption.price)).toFixed(
      2
    )}${handleCurrency(getUserCurrency)}`;
  } else {
    return `+${packOption.price}`;
  }
};

const isOptionSelected = (packOption) => {
  return checkoutStore.getPackOptions.includes(packOption);
};

const selectOption = (option) => {
  if (!isOptionSelected(option.id)) {
    console.log(option.rules?.disable);
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });

    let assign = [];
    if (option.rules?.assign) {
      assign = [option.rules.assign[0]];
    }

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id, ...assign],
    });
  } else {
    let otherOptions = checkoutStore.getPackOptions.filter(
      (packOpt) => packOpt !== option.id
    );
    if (option?.const_title === "preferred_heroes") {
      if (oneTrickOption.value) {
        otherOptions = otherOptions?.filter(
          (op) => op !== oneTrickOption.value?.id
        );
      }
    }

    checkoutStore.setPackOptions({
      options: [...otherOptions],
    });
  }
};

const selectedOptions = computed(() => {
  const options = packOptions.value
    ?.filter((op) => checkoutStore.getPackOptions.includes(op.id))
    ?.map((op) => op.title)
    ?.join(", ");

  return options;
});

const selectedOptionDescription = computed(() => {
  if (packOptions.value.length > 0) {
    let description = "";
    packOptions.value.forEach((option) => {
      let textBreak = description.length > 0 ? "<br/>" : "";
      description = `${description}${textBreak}<p class='f-w-400'><span class='t-orange f-w-600'>${option.title}: </span>${option.description}</p>`;
    });
    return description;
  }
  return "";
});

onMounted(() => {
  eventBus.on("closeCartOption", closeOpen);
});
onBeforeUnmount(() => {
  eventBus.off("closeCartOption", closeOpen);
});
</script>

<style lang="scss">
.cart_option_container {
  display: flex;
  height: 40px;
  padding: 0px 12px;
  justify-content: space-between;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
  align-self: stretch;
  border: 1px solid var(--Stroke-Medium, #27292b);
  background: var(--BG-Medium, #121314);
  position: relative;
  .divisions_list_container {
    position: absolute;
    top: 105%;
    left: 0%;
    width: 100%;
    height: max-content;
    max-height: 30vh;
    overflow: auto;
    background-color: var(--bg-medium);
    border: 1px solid var(--stroke-medium);
    z-index: 9999;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    padding: 6px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    z-index: 10;
    gap: 6px;
    .item {
      width: 100%;
      height: 48px;
      outline: none;
      border: none;
      text-align: start;
      padding: 11px;
      border-radius: 3px;
      -moz-border-radius: 3px;
      -webkit-border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0px;
      z-index: 1;
      @media screen and (max-width: 480px) {
        padding: 16px;
      }

      &.active_item {
        background-color: var(--bg-main);
        color: var(--white);
      }
    }
  }
}
</style>
